import PropTypes from 'prop-types'
import clsx from 'clsx'

const ImagePlaceholder = ({ isStatic, imgRatio }) => (
  <div
    className="image-placeholder"
    style={{ paddingTop: `${imgRatio * 100}%` }}
  >
    <svg
      className={clsx('image-placeholder__logo', { 'is-static': isStatic })}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_2"
      viewBox="0 0 79.94 103.64"
    >
      <g id="AW">
        <path
          className="cls-1"
          d="M79.94,51.81c0-.11-.04-.2-.11-.27L47.11,18.82l6.16-6.15c1.64-1.65,3.82-2.55,6.16-2.55s4.51.9,6.16,2.55c1.64,1.64,2.54,3.82,2.54,6.16s-.91,4.51-2.55,6.16l-2.09,2.09c-.14.14-3.94,4.18-3.8,4.33l6.62,6.62c.13.13,4.19-3.67,4.33-3.8l2.09-2.1c3.55-3.54,5.51-8.27,5.51-13.3s-1.95-9.76-5.51-13.31c-3.54-3.55-8.27-5.51-13.31-5.51s-9.76,1.96-13.31,5.51l-6.24,6.24c0-.1-.03-.2-.1-.27l-5.97-5.96C30.26,1.96,25.52,0,20.49,0S10.73,1.96,7.18,5.51C3.63,9.05,1.68,13.78,1.68,18.82s1.95,9.77,5.51,13.31l6.15,6.16L.11,51.51c-.08.06-.11.16-.11.26,0,0,0,.02,0,.03,0,0,0,.02,0,.03,0,.11.04.2.11.27l32.72,32.72-6.16,6.15c-1.64,1.65-3.82,2.55-6.16,2.55s-4.51-.9-6.16-2.55c-1.64-1.64-2.54-3.82-2.54-6.16s.91-4.51,2.55-6.16l2.09-2.09c.14-.14,3.94-4.18,3.8-4.33l-6.62-6.62c-.13-.13-4.19,3.67-4.33,3.8l-2.09,2.1c-3.55,3.54-5.51,8.27-5.51,13.3s1.95,9.76,5.51,13.31c3.54,3.55,8.27,5.51,13.31,5.51s9.76-1.96,13.31-5.51l6.24-6.24c0,.1.03.2.1.27l5.97,5.96c3.54,3.55,8.28,5.51,13.31,5.51s9.76-1.95,13.3-5.51c3.55-3.54,5.51-8.27,5.51-13.3s-1.95-9.77-5.51-13.31l-6.16-6.16,13.22-13.23c.08-.06.11-.16.11-.26,0,0,0-.02,0-.03,0,0,0-.02,0-.03ZM59.16,45.17s0,0,0,0h0s0,0,0,0ZM39.96,25.98l12.5,12.5c-1.18.97-4.14,3.76-4.25,3.87l-2.09,2.09c-1.65,1.64-3.83,2.54-6.16,2.54s-4.51-.9-6.16-2.54l-13.04-13.04h0l6.62,6.62c.14.14,4.19-3.65,4.32-3.79l8.25-8.25h0ZM14.34,12.66c3.4-3.39,8.92-3.39,12.31,0l6.13,6.13s.02.02.04.03l-8.25,8.26c-.07.07-3.99,4.03-3.99,4.13l-6.23-6.23c-3.4-3.4-3.4-8.92,0-12.31ZM26.65,51.59c.08.08.17.16.25.24-.07.07-.14.14-.22.21l-2.1,2.1c-.07.06-4.07,3.94-4.07,4.04,0,0,0,0,0,0l-6.38-6.38,6.37-6.37s0,0,0,0l6.16,6.16ZM20.79,58.48h0s0,0,0,0h0ZM39.98,77.67l-12.5-12.5c1.18-.97,4.14-3.76,4.25-3.87l2.09-2.09c1.65-1.64,3.83-2.54,6.16-2.54s4.51.9,6.16,2.54l13.04,13.04s0,0,0,0l-6.62-6.62c-.14-.14-4.19,3.65-4.32,3.79l-8.25,8.25s0,0,0,0ZM65.6,90.98c-3.4,3.39-8.92,3.39-12.31,0l-6.13-6.13s-.02-.02-.04-.03l8.25-8.26c.07-.07,3.99-4.03,3.99-4.13h0l6.23,6.23c3.4,3.4,3.4,8.92,0,12.31ZM53.3,52.05c-.08-.08-.17-.16-.25-.24.07-.07.15-.14.22-.21l2.1-2.1c.07-.06,4.07-3.94,4.07-4.04h0s6.38,6.38,6.38,6.38l-6.37,6.37s0,0,0,0l-6.16-6.16Z"
          fill="#000"
        />
      </g>
    </svg>
  </div>
)

ImagePlaceholder.defaultProps = {
  isStatic: false,
  imgRatio: 1,
}

ImagePlaceholder.propTypes = {
  isStatic: PropTypes.bool,
  imgRatio: PropTypes.number,
}

export default ImagePlaceholder
